import { useState } from "react";
import apiAgent from "../../api/apiAgent";
import { tMsg } from "../../components/ToastNotifications";
import _ from "lodash";
import { useSetChangesMade } from "../../components/Publishing/utils";

export const removeQuotes = (values: string[]) => {
  return values.map((v) => v.replaceAll('"', ""));
};

export const useRemoveTagsFromNodes = (field: "place" | "topics") => {
  const setChangesMade = {
    landmark: useSetChangesMade("landmark"),
    moment: useSetChangesMade("moment"),
  };

  const removeTagsFromModel = async (
    valuesToRemove: string[],
    modelName: "landmark" | "moment"
  ) => {
    console.log("valuesToRemove", valuesToRemove);
    try {
      const getResponse = await apiAgent.DataType.getAll(modelName);
      const resolvedData = getResponse.data.reduce((arr: any[], m: any) => {
        // console.log("model", m[model], valuesToRemove);
        const currentArray = removeQuotes(m[field] || []);
        const removed = _.remove(currentArray, (item) =>
          _.includes(valuesToRemove, item)
        );
        if (removed.length < 1) return arr;
        return [...arr, { id: m.id, [field]: currentArray }];
      }, []);

      console.log("resolveddata", resolvedData);
      if (resolvedData.length < 1) return;
      const response = await apiAgent.DataType.update(modelName, {
        bulk_fields: resolvedData,
        fields_to_set: [field],
        fields_to_match: ["id"],
      });
      if (response.status === 200) {
        tMsg.success(
          `Removed ${resolvedData.length} tags from ${_.capitalize(
            modelName
          )} nodes`
        );
        setChangesMade[modelName]();
      }
    } catch (err) {
      console.log(err);
      tMsg.error("Error updating tags in landmarks and moments");
    }
  };

  return async (valuesToRemove: string[]) => {
    if (valuesToRemove.length < 1) return;
    await removeTagsFromModel(valuesToRemove, "moment");
    await removeTagsFromModel(valuesToRemove, "landmark");
  };
};

export const useModifyTagsFromNodes = (field: "place" | "topics") => {
  const setChangesMade = {
    landmark: useSetChangesMade("landmark"),
    moment: useSetChangesMade("moment"),
  };
  const modifyTagFromModel = async (
    oldValue: string,
    newValue: string,
    modelName: "landmark" | "moment"
  ) => {
    console.log("changing - ", oldValue, newValue);
    try {
      const getResponse = await apiAgent.DataType.getAll(modelName);
      const resolvedData = getResponse.data.reduce((arr: any[], m: any) => {
        console.log("model", m[field], oldValue);
        const oldArray = removeQuotes(m[field] || []);
        if (!_.includes(oldArray, oldValue)) return arr;
        const removedArray = oldArray.filter((v: string) => v !== oldValue);
        const newArray = [...removedArray, newValue];
        return [...arr, { id: m.id, [field]: newArray }];
      }, []);

      console.log("resolveddata", resolvedData);
      if (resolvedData.length < 1) return;
      const response = await apiAgent.DataType.update(modelName, {
        bulk_fields: resolvedData,
        fields_to_set: [field],
        fields_to_match: ["id"],
      });
      if (response.status === 200) {
        tMsg.success(
          `Modified ${resolvedData.length} tags from ${_.capitalize(
            modelName
          )} nodes`
        );
        setChangesMade[modelName]();
      }
    } catch (err) {
      console.log(err);
      tMsg.error("Error updating tags in landmarks and moments");
    }
  };

  return async (oldValue: string, newValue: string) => {
    if (oldValue === newValue) return;
    await modifyTagFromModel(oldValue, newValue, "moment");
    await modifyTagFromModel(oldValue, newValue, "landmark");
  };
};
